import { LogManager } from '../../../common/port/log/log.manager.port';
import { AccountMetricInsightsMetricType } from '../../dtos/challenge-insights/account-metrics-insights-metric-type.enum';
import { GetAccountMetricsInsightsAveragesRequestDto } from '../../dtos/challenge-insights/get-account-metrics-insights-averages.request.dto';
import { GetAccountMetricsInsightsAveragesResponseDto } from '../../dtos/challenge-insights/get-account-metrics-insights-averages.response.dto';
import { GetAccountMetricsInsightsAveragesPresenter } from '../../presenters/challenge-insights/get-account-metrics-insights-averages.presenter';
import { GetAccountMetricsInsightDigitalIntensityAverageQuery } from '../../queries/challenge-insights/digital-intensity/get-account-metrics-insight-digital-intensity-average.query';
import { GetAccountMetricsInsightDigitalWorkingHoursAverageQuery } from '../../queries/challenge-insights/digital-working-hours/get-account-metrics-insight-digital-working-hours-average.query';
import { GetAccountMetricsInsightFocusV1AverageQuery } from '../../queries/challenge-insights/focus-v1/get-account-metrics-insight-focus-v1-average.query';
import { GetAccountMetricsInsightSelfReportAverageQuery } from '../../queries/challenge-insights/self-report/get-account-metrics-insight-self-report-average.query';
import { GetAccountMetricsInsightSentimentAverageQuery } from '../../queries/challenge-insights/sentiment/get-account-metrics-insight-sentiment-average.query';
import { GetAccountMetricsInsightTimeInAppsAverageQuery } from '../../queries/challenge-insights/time-in-apps/get-account-metrics-insight-time-in-apps-average.query';
import { GetAccountMetricsInsightTimeInCallsAverageQuery } from '../../queries/challenge-insights/time-in-calls/get-account-metrics-insight-time-in-calls-average.query';
import { GetAccountMetricsInsightTimeInCategoriesAverageQuery } from '../../queries/challenge-insights/time-in-categories/get-account-metrics-insight-time-in-categories-average.query';
import { GetAccountMetricsInsightTimeInMeetingsAverageQuery } from '../../queries/challenge-insights/time-in-meetings/get-account-metrics-insight-time-in-meetings-average.query';

export class GetAccountMetricsInsightsAveragesCompositeController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly getAccountMetricsInsightDigitalWorkingHoursAverageQuery: GetAccountMetricsInsightDigitalWorkingHoursAverageQuery,
    protected readonly getAccountMetricsInsightFocusV1AverageQuery: GetAccountMetricsInsightFocusV1AverageQuery,
    protected readonly getAccountMetricsInsightDigitalIntensityAverageQuery: GetAccountMetricsInsightDigitalIntensityAverageQuery,
    protected readonly getAccountMetricsInsightSentimentAverageQuery: GetAccountMetricsInsightSentimentAverageQuery,
    protected readonly getAccountMetricsInsightTimeInMeetingsAverageQuery: GetAccountMetricsInsightTimeInMeetingsAverageQuery,
    protected readonly getAccountMetricsInsightTimeInCallsAverageQuery: GetAccountMetricsInsightTimeInCallsAverageQuery,
    protected readonly getAccountMetricsInsightTimeInAppsAverageQuery: GetAccountMetricsInsightTimeInAppsAverageQuery,
    protected readonly getAccountMetricsInsightTimeInCategoryAverageQuery: GetAccountMetricsInsightTimeInCategoriesAverageQuery,
    protected readonly getAccountMetricsInsightChallengeTargetResultAverageQuery: GetAccountMetricsInsightSelfReportAverageQuery,
    protected readonly presenter: GetAccountMetricsInsightsAveragesPresenter
  ) {}
  async get(
    props: GetAccountMetricsInsightsAveragesRequestDto
  ): Promise<GetAccountMetricsInsightsAveragesResponseDto> {
    this.logManager.debug(
      'GetAccountMetricsInsightsAveragesCompositeController has been called with props:',
      props
    );

    const metricType = props.params.metricType;

    if (metricType === AccountMetricInsightsMetricType.SelfReport) {
      const challengeTargetResult =
        await this.getAccountMetricsInsightChallengeTargetResultAverageQuery.execute(
          props
        );
      return this.presenter.toResponse(challengeTargetResult);
    }

    if (metricType === AccountMetricInsightsMetricType.DigitalWorkingHours) {
      const digitalWorkingHours =
        await this.getAccountMetricsInsightDigitalWorkingHoursAverageQuery.execute(
          props
        );
      return this.presenter.toResponse(digitalWorkingHours);
    }

    if (metricType === AccountMetricInsightsMetricType.FocusV1) {
      const focusV1 =
        await this.getAccountMetricsInsightFocusV1AverageQuery.execute(props);
      return this.presenter.toResponse(focusV1);
    }

    if (
      props.params.metricType ===
      AccountMetricInsightsMetricType.DigitalIntensity
    ) {
      const digitalIntensity =
        await this.getAccountMetricsInsightDigitalIntensityAverageQuery.execute(
          props
        );
      return this.presenter.toResponse(digitalIntensity);
    }

    if (metricType === AccountMetricInsightsMetricType.Sentiment) {
      const sentiment =
        await this.getAccountMetricsInsightSentimentAverageQuery.execute(props);
      return this.presenter.toResponse(sentiment);
    }
    if (metricType === AccountMetricInsightsMetricType.TimeInMeetings) {
      const timeInMeetings =
        await this.getAccountMetricsInsightTimeInMeetingsAverageQuery.execute(
          props
        );
      return this.presenter.toResponse(timeInMeetings);
    }

    if (metricType === AccountMetricInsightsMetricType.TimeInCalls) {
      const timeInCalls =
        await this.getAccountMetricsInsightTimeInCallsAverageQuery.execute(
          props
        );
      return this.presenter.toResponse(timeInCalls);
    }

    if (metricType === AccountMetricInsightsMetricType.TimeInApp) {
      const timeInApps =
        await this.getAccountMetricsInsightTimeInAppsAverageQuery.execute(
          props
        );
      return this.presenter.toResponse(timeInApps);
    }

    if (metricType === AccountMetricInsightsMetricType.TimeInCategory) {
      const timeInCategory =
        await this.getAccountMetricsInsightTimeInCategoryAverageQuery.execute(
          props
        );
      return this.presenter.toResponse(timeInCategory);
    }
  }
}
